import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { AllDeliveryDetailsDto } from 'src/app/Model/Shipping/all-delivery-details-dto';
import { AssignShippingDto } from 'src/app/Model/Shipping/assign-shipping-dto';
import { CCAvenueResponse } from 'src/app/Model/Shipping/ccavenue-response';
import { CollectPayReq } from 'src/app/Model/Shipping/collect-pay-req';
import { Customer } from 'src/app/Model/Shipping/customer';
import { DeliveryFeedBack } from 'src/app/Model/Shipping/delivery-feed-back';
import { MapOptimizedResponse } from 'src/app/Model/Shipping/map-optimized-response';
import { MapOtpimizationModel } from 'src/app/Model/Shipping/map-otpimization-model';
import { PaytmResponse } from 'src/app/Model/Shipping/paytm-response';
import { RaiseDisputeOnShippingDto } from 'src/app/Model/Shipping/raise-dispute-on-shipping-dto';
import { ReasonsOfCancellation } from 'src/app/Model/Shipping/reasons-of-cancellation';
import { RouteAsPerMap } from 'src/app/Model/Shipping/route-as-per-map';
import { SendOtpDto } from 'src/app/Model/Shipping/send-otp-dto';
import { ServiceManCurrentLocation } from 'src/app/Model/Shipping/service-man-current-location';
import { ShippingFareRiderDto } from 'src/app/Model/Shipping/shipping-fare-rider-dto';
import { ShippingFareShippingWise } from 'src/app/Model/Shipping/shipping-fare-shipping-wise';
import { ShippingSequanceData } from 'src/app/Model/Shipping/shipping-sequance-data';
import { TripsAndShippingsDto } from 'src/app/Model/Shipping/trips-and-shippings-dto';
import { UpiCodeResponse } from 'src/app/Model/Shipping/upi-code-response';
import { UpiPaymentDetails } from 'src/app/Model/Shipping/upi-payment-details';
import { WalletOfferRequestDto } from 'src/app/Model/Shipping/wallet-offer-request-dto';
import { WalletOffers } from 'src/app/Model/Shipping/wallet-offers';
import { DistanceAndWeather } from 'src/app/Model/Shipping/way-point';
import { WhatsAppMessageDto } from 'src/app/Model/Shipping/whats-app-message-dto';

@Injectable({
  providedIn: 'root'
})
export class ShippingManagerService {

  header: HttpHeaders | { [header: string]: string | string[]; };

  constructor(
    private http: HttpClient,
  ) { }


  getShippingDetails(url: string, employeeId: string, currDate: string) {
    return this.http.get<AllDeliveryDetailsDto[]>(url + "/" + employeeId + "/" + currDate);
  }

  getSequenceData(url: string, employeeCode: string): Observable<any> {
    return this.http.get<ShippingSequanceData[]>(url + '/' + employeeCode)
  }


  saveShipping(url: string, obj: AssignShippingDto) {
    return this.http.post(
      url, obj, { responseType: 'json' }
    )
  }

  deleteSequenceData(url: string, employeeCode: string): Observable<any> {
    return this.http.delete<any>(url + '/' + employeeCode)
  }

  getTrafficDetails(url: string, fromLat: string, fromLng: string, toLat: string, toLng: string, requiredWeather: string, companyCode: number): Observable<any> {
    return this.http.get<DistanceAndWeather>(url + '/' + fromLat + '/' + fromLng + '/' + toLat + '/' + toLng + '/' + requiredWeather + '/' + companyCode);
  }

  saveServiceManCurrentLocation(url: string, obj: ServiceManCurrentLocation[]): Observable<any> {
    return this.http.post<any>(
      url, obj
    );
  }


  getShippingDetailsByInvNo(url: string, invNo: string) {
    return this.http.get<AllDeliveryDetailsDto[]>(url + "/" + invNo);
  }

  getReasonOfPickupCancellation(url: string) {
    return this.http.get<ReasonsOfCancellation[]>(url);
  }

  getReasonOfCancellation(url: string, type: string) {
    return this.http.get<ReasonsOfCancellation[]>(url + "/" + type);
  }

  insertSubGroupAcc2(url: string, obj: any): Observable<any> {
    return this.http.post<any>(
      url, obj
    );
  }

  uploadImage(url: string, obj: string, file: File): Observable<any> {

    const formData = new FormData();
    formData.append('file', file);
    formData.append('invoiceNo', obj);

    return this.http.post(
      url,
      formData
    );
  }

  getBankDataByLoc(url: string, locCode: number) {
    return this.http.get<any>(url + '/' + locCode)
    // .pipe(
    //   catchError(this.handleError('getBankDataByLoc()', []))
    // );
  }

  getCouponAmount(url: string, code: string, locId: number) {
    return this.http.get<any>(url + code + "/" + locId)
  }

  getWalletTransaction(url: string, email: string) {
    return this.http.get<any>(url + "/" + email, {
      responseType: "json",
    });
  }

  getWalletOffers(url: string, walletOfferRequestDto: WalletOfferRequestDto) {
    return this.http.post<WalletOffers[]>(url, walletOfferRequestDto, { responseType: "json" });
  }

  sendSms(url: string, customerId: string, amount: number, locId: string) {
    let params = new HttpParams();
    params = params.append('customerId', customerId);
    params = params.append('amount', "" + amount);
    params = params.append('locId', locId);

    return this.http.get<string>(url,
      { params: params, headers: this.header, responseType: "json" })
    // .pipe(
    //   catchError(this.handleError('sendSms', 'I am an error')
    //   ));
  }

  getQrCode(url: string, locId: number, amount: number, paymentType: string) {
    let params = new HttpParams();
    params = params.append('locId', "" + locId);
    params = params.append('amount', "" + amount);
    params = params.append('paymentType', paymentType);
    return this.http.get<UpiCodeResponse>(url,
      { params: params })
  }

  collectPayByVPA(url: string, obj: CollectPayReq): Observable<any> {

    return this.http.post<string>(
      url, obj,
      { headers: this.header, responseType: 'text' as 'json' }
    )
    // .pipe(
    //   catchError(this.handleError('collectPayByVPA', 'I am an error')
    //   ));
  }

  getTransactionDetails(url: string, merchantTransId: string, locId: number) {
    let params = new HttpParams();
    params = params.append('merchantTnxId', merchantTransId);
    params = params.append('locId', "" + locId);
    return this.http.get<UpiPaymentDetails>(url,
      { params: params })
  }

  getQrCodePaytm(url: string, amount: string, orderId: string) {
    return this.http.get<any>(url + "/" + amount + "/" + orderId)
  }

  sendPaymentRequestLink(url: string, mobile: string) {
    return this.http.get<any>(url + "/" + mobile)
  }

  searchEdcRequest(url: string, amtInPaisa: string, transNo: string, locId: number) {
    return this.http.get<any>(url + "/" + amtInPaisa + "/" + transNo + "/" + locId)
  }

  checkPaytmStatus(url: string, transNo: string, locId: number) {
    return this.http.get<any>(url + "/" + transNo + "/" + locId)
  }

  savePaymentResponse(url: string, paytmResponse: PaytmResponse) {
    return this.http.post<any>(url, paytmResponse, { responseType: "json" });
  }

  getGatewaySetup(url: string, locId: number, provider: string) {
    return this.http.get<any>(url + "/" + locId + "/" + provider)
  }

  sendGatewayPaymentRequest(url: string, transNo: string) {
    return this.http.get<any>(url + "/" + transNo)
  }

  saveGatewayPaymentResponse(url: string, response: CCAvenueResponse) {
    return this.http.post<any>(url, response, { responseType: "json" });
  }

  sendWhatsAppMessage(url: string, obj: WhatsAppMessageDto, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('formData', new Blob([JSON.stringify(obj)], { "type": "application/json" }));
    return this.http.post(
      url,
      formData
    );
  }

  getCustomerInitialData(url: string, locId: number) {
    return this.http.get<any>(url + "/" + locId);
  }

  getStatesList(url: string, countryCode: number) {
    return this.http.get<any>(url + '/' + countryCode)
    // .pipe(
    //   catchError(this.handleError('getStatesList()', []))
    // );
  }

  getDistrictsByStateCode(url: string, stateCode: number) {
    return this.http.get<any>(url + '/' + stateCode)
    // .pipe(
    //   catchError(this.handleError('getDistrictsByStateCode()', []))
    // );
  }
  insertCustomer(url: string, obj: Customer): Observable<any> {
    return this.http.post<string>(url, obj)
    // .pipe(
    //   catchError(this.handleError('insertCustomer', 'I am an error')
    //   ));
  }

  getCustomerSearch(url: string, mobileNo: string) {
    return this.http.get<any>(url + '/' + mobileNo)
    // .pipe(
    //   catchError(this.handleError('getCustomerSearch()', []))
    // );
  }

  sendWhatsAppOptInByMobileNo(url: string, companyCode: number, mobileNo: string) {
    return this.http.get(url + "/" + companyCode + "/" + mobileNo, {
      responseType: "json",
    });
  }

  sendWhatsAppOTPByMobileNo(url: string, companyCode: number, mobileNo: string, otp: string) {
    return this.http.get(url + "/" + companyCode + "/" + mobileNo + "/" + otp, {
      responseType: "json",
    });
  }

  getLocationById(url: string, locationCode: number) {
    return this.http.get<any>(url + '/' + locationCode)
  }

  getOptimizeRoute(url: string, obj: MapOtpimizationModel): Observable<any> {
    return this.http.post<MapOptimizedResponse[]>(
      url, obj
    );
  }

  saveSequenceData(url: string, obj: ShippingSequanceData[]): Observable<any> {
    return this.http.post<ShippingSequanceData[]>(
      url, obj
    );
  }

  saveRouteDetails(url: string, obj: RouteAsPerMap[]): Observable<any> {
    return this.http.post<RouteAsPerMap[]>(
      url, obj
    );
  }

  getFeedBack(url: string, assignNo: string): Observable<any> {
    return this.http.get<DeliveryFeedBack[]>(url + '/' + assignNo);
  }

  insertFeedBack(url: string, rating: DeliveryFeedBack[]): Observable<any> {
    return this.http.post<any>(
      url, rating
    );
  }

  acceptOrder(url: string, transNo: string, email: string, status: string): Observable<any> {
    return this.http.get<AssignShippingDto>(url + '/' + transNo + '/' + email + '/' + status);
  }

  getDeliveryFareDetails(url: string, empId: string): Observable<any> {
    return this.http.get<ShippingFareRiderDto[]>(url + '/' + empId);
  }

  getShippingSummaryData(url: string, empId: string): Observable<any> {
    return this.http.get<any[]>(url + '/' + empId);
  }

  getShippingSummaryAccountData(url: string, empId: string, fromDate: string, toDate: string): Observable<any> {
    return this.http.get<any[]>(url + '/' + empId + '/' + fromDate + '/' + toDate);
  }

  getRiderRatingData(url: string, email: string, fromDate: string, toDate: string): Observable<any> {
    return this.http.get<any[]>(url + '/' + email + '/' + fromDate + '/' + toDate);
  }
  
  getTripNosAndShippingNoByEmpIdAndDate(url: string, empId: string, fromDate: string): Observable<any> {
    return this.http.get<TripsAndShippingsDto[]>(url + '/' + empId + '/' + fromDate);
  }

  getDeliveryFareDetailsByRider(url: string, empId: string, fromDate: string, tripNo: string, shippingNo: string): Observable<any> {
    return this.http.get<ShippingFareShippingWise[]>(url + '/' + empId + '/' + fromDate + '/' + tripNo + '/' + shippingNo);
  }

  saveRaiseDispute(url: string, obj: RaiseDisputeOnShippingDto): Observable<any> {
    return this.http.post<RaiseDisputeOnShippingDto>(
      url, obj
    );
  }

  sendMessageByMailChimp(url: string, obj: SendOtpDto): Observable<any> {
    return this.http.post<SendOtpDto>(
      url, obj
    );
  }
}
